import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';

import { Element, Section } from 'src/constants/footfall';
import UserLink from 'src/modules/shared/links/userLink';
import RelativeTime from 'src/components/relativeTime';
import Roles from 'src/components/roles';
import { titleLarge } from 'styles-js/mixins/typography';
import { Size } from 'src/components/avatar';

export default function PollDetails() {
  const { title, author, dateCreated, voters } = useSelector((state) => state.pages.singlePost.post);

  return (
    <Header>
      <Title>{title}</Title>
      <StyledUserLink
        avatarSize={Size.Small}
        signupContext={{
          element: Element.AVATAR,
          section: Section.POST,
        }}
        user={author}
      />
      <StyledUserLink
        signupContext={{
          element: Element.AVATAR,
          section: Section.COMMUNITY_POSTS_POLL,
        }}
        user={author}
      />
      <Roles roles={author.roles} />
      <Separator />
      <RelativeTime rawTime={dateCreated} />
      <Separator />
      {`${voters} ${voters === 1 ? i18n.t('Voter') : i18n.t('Voters')}`}
    </Header>
  );
}

const Header = styled.div`
  margin-bottom: 30px;
`;
const Title = styled.h1`
  ${titleLarge};
  margin-bottom: 10px;
`;
const StyledUserLink = styled(UserLink)`
  margin-right: 12px;
  color: ${({ theme }) => theme.colorTextBlack};
  &:hover {
    color: ${({ theme }) => theme.colorTextBlack};
  }
`;
const Separator = styled.span`
  ::after {
    content: '•';
    color: ${({ theme }) => theme.colorGreyDark};
    margin: 0 12px;
  }
`;
